import { makeStyles } from 'tss-react/mui';

export default makeStyles({ name: 'MobileSearchField' })({
    container: {
        display: 'flex',
        flexDirection: 'column',
        gap: 12,
        width: '100%',
        boxSizing: 'border-box'
    },
    field: {
        width: '100%',
        boxSizing: 'border-box',
        background: '#F8F8F8',
        borderRadius: 8,
        padding: 8,
        color: '#232323',
        '& input': {
            padding: 0,
            fontSize: 16,
            fontWeight: 500,
            lineHeight: '24px',
            letterSpacing: '-0.32px',
            caretColor: '#232323'
        }
    },
    input: {
        display: 'flex',
        padding: 0
    },
    icon: {
        marginRight: 4,
        width: 24,
        height: 24,
        color: '#8E8E8E',
        fontSize: 24
    },
    clear: {
        width: 24,
        height: 24,
        background: 'transparent'
    },
    list: {
        marginTop: 8
    },
    label: {
        width: 24,
        height: 24,
        display: 'block',
        fontSize: 10,
        fontWeight: 400,
        lineHeight: '24px',
        color: '#8E8E8E',
        marginRight: 4,
        letterSpacing: '0.32px'
    }
});
